import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "./api";

const EditContext = createContext(null);

export const EditProvider = ({ children }) => {
  const [editMode, setEditMode] = useState(false);
  const [authed, setAuthed] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    (async () => {
      const t = getToken();
      if (!t) return;
      try {
        await api.verify();
        setAuthed(true);
      } catch {
        clearToken();
        setAuthed(false);
      }
    })();
  }, []);

  const login = async (password) => {
    const data = await api.login(password);
    setToken(data.token);
    setAuthed(true);
    setEditMode(true);
    setShowLogin(false);
  };

  const logout = () => {
    clearToken();
    setAuthed(false);
    setEditMode(false);
  };

  const toggleEdit = () => {
    if (!authed) {
      setShowLogin(true);
    } else {
      setEditMode((v) => !v);
    }
  };

  return (
    <EditContext.Provider
      value={{ editMode, authed, showLogin, setShowLogin, login, logout, toggleEdit }}
    >
      {children}
    </EditContext.Provider>
  );
};

export const useEdit = () => {
  const ctx = useContext(EditContext);
  if (!ctx) throw new Error("useEdit must be used within EditProvider");
  return ctx;
};
